export const getBreadcrumbsUri = (uri: string) => {
  // eslint-disable-next-line no-useless-escape
  return uri.replace(/^.*\/\/[^\/]+/, "")
}
